import { render, staticRenderFns } from "./AddNewTeam.vue?vue&type=template&id=1343c9ad&scoped=true&"
import script from "./AddNewTeam.vue?vue&type=script&lang=js&"
export * from "./AddNewTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1343c9ad",
  null
  
)

export default component.exports